export default "<div class=\"matrixManager_Root\">\n    <div data-dojo-attach-point=\"__matrixGridContainer\">\n\n    </div>\n</div>"